import { Box } from '@mui/material';
import { StatusChip } from '../../../common/components';
import {
  SUPPLY_ORDER_ARTICLE_CHIP_CONFIG as CHIP_CONFIG,
} from '../constants/supplyOrdersConstants';

/** Muestra cada proyecto o uso interno con la misma presentación que los artículos. */
const SupplyOrderProjectChips = ({ labels }) => (
  <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', py: 0.5, minWidth: 0 }}>
    {labels.map((label) => (
      <StatusChip
        key={label}
        size="small"
        label={label.length > CHIP_CONFIG.maxLabelLength
          ? `${label.slice(0, CHIP_CONFIG.maxLabelLength - 1)}…` : label}
        tooltip={label}
        sx={{ maxWidth: '100%', fontSize: CHIP_CONFIG.fontSize, fontWeight: 500, letterSpacing: 0 }}
      />
    ))}
  </Box>
);

export default SupplyOrderProjectChips;
